import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MysolutionCards } from "../../../../molecules";


interface ISolutionStatistics {
    solutionStatistic: any,
    teamNumber: any
}

const SolutionCardsStatistics: FC<ISolutionStatistics> = (props) => {
    const { solutionStatistic, teamNumber } = props;
    
    const { t } = useTranslation();

    if(!solutionStatistic)
        return <div></div>;

    if(!teamNumber)
        return <div></div>;

    let solutionStatisticsForTheCurrentUser = solutionStatistic.filter( (userStatistics: any) => userStatistics.teamNumber === teamNumber)

    return (
        <div className="solution_statistics_container">
            <h3 className="solution_statistics_heading"> {t("solutionCardsYouSuggestedText")} </h3>
            <MysolutionCards solutionStatistics={solutionStatisticsForTheCurrentUser}/>
        </div>
    )
};

export default SolutionCardsStatistics;